import React from "react";
import usePageTitle from "../hooks/usePageTitle";

const AboutUs = () => {
  usePageTitle("About Us - Agrolinka");

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-sm p-6 md:p-8">
        <h1 className="text-3xl font-bold text-agBlack mb-8">About Us</h1>

        <div className="space-y-6 text-gray-700">
          <p>
            Agrolinka is an agricultural e-commerce business dedicated to
            bringing high-quality farm produce and packaged dried food products
            directly to you, whether you're in Nigeria or across the globe.
          </p>

          <p>
            Founded in 2020 and based in Abuja, Nigeria, Agrolinka was born out
            of a deep belief that every farmer and food producer deserves fair
            access to markets and every customer deserves access to fresh and
            authentic agro-products.
          </p>

          <p>
            At Agrolinka, we source the best fresh and dried agricultural
            products, from locally grown staples to carefully packaged food
            items that meet high standards of quality and safety. Our mission is
            to bridge the gap between farm and table by making it easy for
            customers and those in the diaspora to shop online and pay securely
            for products they know and trust.
          </p>

          <p>
            We are passionate about supporting local agriculture and empowering
            farmers while expanding access to nutritious and sustainable food
            products. By blending technology with tradition, we bring you a
            shopping experience that is trustworthy, convenient, and tailored to
            your needs.
          </p>

          <p>
            Whether you're looking for premium dried foods or fresh produce
            delivered to your doorstep, Agrolinka is your partner in quality and
            convenience.
          </p>

          {/* Our Promise Section */}
          <section className="mt-8">
            <h2 className="text-xl font-semibold text-agBlack mb-4">
              Our Promise:
            </h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Genuine, high-quality agricultural products</li>
              <li>Secure and smooth online shopping</li>
              <li>Reliable delivery and customer support</li>
              <li>
                A commitment to ethical sourcing and sustainable practices
              </li>
            </ul>
          </section>

          <p className="mt-6">
            Thank you for taking the time to learn about Agrolinka. We're
            committed to delivering quality agricultural products with
            transparency, trust, and care. Whether you're exploring our
            offerings for the first time or already enjoy our products, we're
            here to serve you and build lasting relationships grounded in shared
            values and mutual benefit.
          </p>

          <p>
            We invite you to explore our products, stay connected with us on
            social media, or reach out if you have questions because your
            satisfaction and confidence in what we do is at the heart of
            everything we strive for.
          </p>

          {/* Contact Information Section */}
          <section className="mt-8">
            <h2 className="text-xl font-semibold text-agBlack mb-3">
              Contact Information
            </h2>
            <div className="bg-agBg p-4 rounded-md space-y-2">
              <p>
                <strong>📧 Email:</strong>{" "}
                <a
                  href="mailto:info@agrolinka.com"
                  className="text-agGreen hover:underline"
                >
                  info@agrolinka.com
                </a>
              </p>
              <p>
                <strong>📞 Phone:</strong>{" "}
                <a
                  href="tel:+2348065165064"
                  className="text-agGreen hover:underline"
                >
                  +234 806 516 5064
                </a>
              </p>
              <p>
                <strong>🏢 Address:</strong> 13 Akure Street, War College
                Estate, Gwarimpa, Abuja, Nigeria
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
